import React from 'react';
import { FlameIcon, ShieldCheckIcon, WavesIcon } from 'lucide-react';
import { PRODUCT_PRICE, formatPrice } from '../data/config';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type FinalCTAProps = {
  guaranteeEnabled: boolean;
};
export function FinalCTA({
  guaranteeEnabled
}: FinalCTAProps) {
  return <section className="bg-navy px-4 py-6 text-center md:px-12 md:py-8" data-id="element-48" data-mp="879zolewpxa0">
      <h2 className="font-heading text-[24px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-gold md:text-[29px]" data-id="element-49" data-mp="m3ngdsbm9unf">
        One last question.
      </h2>
      <div className="mx-auto mt-2 max-w-[580px] space-y-1.5 text-[14px] leading-[1.45] text-white md:text-[15px]" data-id="element-50" data-mp="vv9ohfsnrdly">
        <p data-id="element-51" data-mp="qwq43jtpq9vp">
          How many times have you finished an aqua fitness class and then needed to start planning the next one?
        </p>
        <p className="text-onNavyMuted" data-id="element-52" data-mp="14tdbyhn7ekge">
          Searching for exercises. Calculating durations. Planning recovery. Finding alternatives. Trying not to repeat
          the same routine.
        </p>
        <p data-id="element-53" data-mp="2c6rbe9i74gon">
          You can keep collecting exercise ideas from different sources — or have complete aquatic workouts with exact
          timings, modifications, and instructor guidance, plus five professional bonuses, all in one collection.
        </p>
      </div>
      <p className="mt-2 font-heading text-[13px] font-extrabold uppercase text-gold md:text-[14px]" data-id="element-54" data-mp="2r2ozd4hyueps">
        Open. Follow. Demonstrate. Teach.
      </p>

      <div className="mx-auto mt-3 max-w-[220px]" data-id="element-55" data-mp="302c3vz5zs0n2">
        <ProductImage data-id="element-56" data-mp="3010zbx4q2ouw" />
      </div>

      <h3 className="mx-auto mt-2 max-w-[600px] font-heading text-[24px] font-extrabold uppercase leading-[1.1] tracking-[-0.3px] text-white md:text-[30px]" data-id="element-57" data-mp="34tc0127aeeoi">
        <WavesIcon className="mr-1.5 inline h-6 w-6 -translate-y-0.5 text-aqua" strokeWidth={2.5} aria-hidden data-id="element-58" data-mp="39rvnj71j3yiz" />
        AQUA CLASS HUB™
      </h3>
      <p className="mt-0.5 font-heading text-[13px] font-extrabold uppercase text-aqua md:text-[14px]" data-id="element-59" data-mp="3it3awu2ibeya">
        Complete Aqua Fitness Bundle
      </p>
      <p className="mx-auto mt-1 max-w-[600px] font-heading text-[11px] font-bold uppercase leading-tight text-white md:text-[12px]" data-id="element-60" data-mp="1jp4s1kbqipkp">
        The complete ready-to-teach collection for aqua fitness &amp; water aerobics instructors
      </p>
      <p className="mt-1 text-[13px] leading-[1.35] text-onNavyMuted md:text-[14px]" data-id="element-61" data-mp="1npyj2mkh4kht">
        Cardio • Strength • Intervals • Choreography • Mixed Levels • Circuits
      </p>
      <ul className="mt-1.5 space-y-0.5 font-heading text-[11px] font-bold uppercase text-white/85 md:text-[12px]" data-id="element-62" data-mp="22d048zrp7vbp">
        <li data-id="element-63" data-mp="1xi475l7luhrq">6 Main Volumes + 5 FREE Professional Bonuses</li>
        <li data-id="element-64" data-mp="2be825gqayu59">72 Complete Classes + 12 Quick Workout Combos</li>
        <li data-id="element-65" data-mp="27debiflh718o">504 Pages of Practical Instructor Resources</li>
      </ul>
      <p className="mt-2.5 flex flex-wrap items-center justify-center gap-1.5 font-heading text-[14px] font-extrabold uppercase leading-tight text-gold md:text-[16px]" data-id="element-66" data-mp="27c37qfs15thk">
        <FlameIcon className="h-4 w-4 shrink-0" strokeWidth={2.5} aria-hidden data-id="element-67" data-mp="d1hem749l368" />
        Get the complete bundle today for only {formatPrice(PRODUCT_PRICE)} USD!
      </p>
      <div className="mt-2.5" data-id="element-68" data-mp="6xtacdn4q31v">
        <CtaButton mode="checkout" subtext="Get instant access" data-id="element-69" data-mp="6x1ss6qda5ul">
          Yes! I want my complete aqua fitness bundle!
        </CtaButton>
      </div>
      <p className="mt-2 text-[12px] font-semibold text-onNavyMuted md:text-[13px]" data-id="element-70" data-mp="3uadqn2v1qs92">
        Instant Digital Delivery • Complete Professional Collection
      </p>
      {guaranteeEnabled && <p className="mx-auto mt-1.5 max-w-[440px] font-heading text-[11px] font-bold uppercase leading-snug text-white md:text-[12px]" data-id="element-71" data-mp="3kc7u70s0eebl">
          <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-aqua" aria-hidden data-id="element-72" data-mp="36e00d1q9rt4n" />
          7-day money-back guarantee • 6 volumes + 5 free bonuses
        </p>}
    </section>;
}